<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">カメラ一覧</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="openDlgClick(0)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbCameras" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>管理番号：{{ obj.sort_no }}</h4>
                        <h4>録画時間：{{ obj.lapse_stime }} 〜 {{ obj.lapse_etime }}</h4>
                        <h4>録画間隔：{{ dispLapseInterval(obj.lapse_interval) }}</h4>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn small @click="openInformation(obj)"><v-icon>mdi-information-variant</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showInfoDlg" max-width="300px">
            <v-card>
                <v-toolbar color="blue darken-2" dark>
                    <h4>{{ dlgInfo.name }}</h4>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showInfoDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <h4>camera id: {{ dlgInfo.id }}</h4>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgCamera.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="管理番号" v-model="dlgCamera.sort_no" outlined dense type="number" hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field label="名前" v-model="dlgCamera.name" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="8">
                                            <v-text-field label="Camera IP" v-model="dlgCamera.local_ip" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="Port" v-model="dlgCamera.local_port" outlined dense hide-details type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="3" v-show="false">
                                            <v-text-field label="Proxy" v-model="dlgCamera.id" outlined dense disabled hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field label="Basic認証ID" v-model="dlgCamera.loginid" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Basic認証PW" v-model="dlgCamera.loginpw" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field label="Jpegパス" v-model="dlgCamera.jpg_path" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field label="Mjpgパス" v-model="dlgCamera.mjpg_path" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-select label="タイムラプス開始時刻" v-model="dlgCamera.lapse_stime" :items="optTime" outlined dense hide-details></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select label="タイムラプス終了時刻" v-model="dlgCamera.lapse_etime" :items="optTime" outlined dense hide-details></v-select>
                                        </v-col>
                                        <v-col cols="9">
                                            <v-select label="タイムラプス間隔(分)" v-model="dlgCamera.lapse_interval" :items="optInterval" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0" v-show="dlgCamera.id > 0">
                            <v-btn color="error" @click="showDelDlg = true" width="100">削除</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgCamera.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "Cameras",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showInfoDlg: false,
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbCameras: [],
            dlgInfo: {
                id: null,
            },
            dlgCamera: {
                id: 0,
                site_id: 0,
                name: "カメラ01",
                sort_no: 999,
                local_ip: "192.168.1.100",
                local_port: 80,
                loginid: "",
                loginpw: "",
                jpg_path: "/cgi-bin/viewer/video.jpg?resolution=1280x720",
                mjpg_path: "/video1s1.mjpg",
                lapse_stime: "06:00",
                lapse_etime: "18:00",
                lapse_interval: 60,
            },
            optTime: [
                { text: "00:00", value: "00:00" },
                { text: "00:30", value: "00:30" },
                { text: "01:00", value: "01:00" },
                { text: "01:30", value: "01:30" },
                { text: "02:00", value: "02:00" },
                { text: "02:30", value: "02:30" },
                { text: "03:00", value: "03:00" },
                { text: "03:30", value: "03:30" },
                { text: "04:00", value: "04:00" },
                { text: "04:30", value: "04:30" },
                { text: "05:00", value: "05:00" },
                { text: "05:30", value: "05:30" },
                { text: "06:00", value: "06:00" },
                { text: "06:30", value: "06:30" },
                { text: "07:00", value: "07:00" },
                { text: "07:30", value: "07:30" },
            ],
            optInterval: [
                { text: "なし", value: 0 },
                { text: "1分間隔", value: 60 },
                { text: "2分間隔", value: 120 },
                { text: "3分間隔", value: 180 },
                { text: "4分間隔", value: 240 },
                { text: "5分間隔", value: 300 },
                { text: "10分間隔", value: 600 },
            ],
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseFeeder = this.axiosGetCameras();
        //-----------------------
        //上記の終了を待つ
        await promiseFeeder;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        this.optCreate();
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        dispLapseInterval(val) {
            let ret = "";
            for (let obj of this.optInterval) {
                if (obj.value == val) ret = obj.text;
            }
            return ret;
        },
        //===================================================
        optCreate() {
            this.optTime = [];
            for (let i = 0; i < 48; i++) {
                let t = this.$moment("2022-01-01")
                    .add(i * 30, "minutes")
                    .format("HH:mm");
                this.optTime.push({ text: t, value: t });
            }
        },
        //===================================================
        async axiosGetCameras() {
            await this.axios({
                method: "GET",
                url: "/web/api/cameras",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbCameras = response.data.json;
                this.optFeeders = [{ text: "-----", value: 0 }];
                for (let item of this.dbCameras) {
                    this.optFeeders.push({ text: item.name, value: item.id });
                }
            });
        },
        //===================================================
        // 確認ダイアログ表示
        //===================================================
        openInformation(camera) {
            this.dlgInfo = camera;
            this.showInfoDlg = true;
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbCameras) {
                    if (obj.id == primaryKey) {
                        this.dlgCamera = JSON.parse(JSON.stringify(obj));
                    }
                }
            } else {
                this.dlgCamera["id"] = 0;
                this.dlgCamera["name"] = "新規 カメラ";
                this.dlgCamera["sort_no"] = "100";
                this.dlgCamera["local_ip"] = "192.168.1.100";
                this.dlgCamera["local_port"] = 80;
                this.dlgCamera["loginid"] = "";
                this.dlgCamera["loginpw"] = "";
                this.dlgCamera["jpg_path"] = "/cgi-bin/viewer/video.jpg?resolution=1280x720";
                this.dlgCamera["mjpg_path"] = "/video1s1.mjpg";
                this.dlgCamera["lapse_stime"] = "06:00";
                this.dlgCamera["lapse_etime"] = "18:00";
                this.dlgCamera["lapse_interval"] = 60;
                delete this.dlgCamera["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgCamera["name"]) ErrCount++;
            if (!this.dlgCamera["sort_no"]) ErrCount++;
            if (!this.dlgCamera["local_ip"]) ErrCount++;
            if (!this.dlgCamera["local_port"]) ErrCount++;
            if (!this.dlgCamera["jpg_path"]) ErrCount++;
            if (!this.dlgCamera["mjpg_path"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgCamera));
            axiosData["site_id"] = this.myInfo.site_id;
            delete axiosData["modified"];
            //-----------------------------------
            const primaryKey = this.dlgCamera.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/cameras";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetCameras();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgCamera.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/cameras/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetCameras();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
